<script>
	import ButtonViewsXpages from './componentes/ButtonViewsXpages.svelte';
	import Helper from './components/Helper.svelte';
  import Input from './componentes/Forms/Input.svelte';
  import Modal from './components/Modal.svelte';
  import { viewsXpages, registerXpage } from './stores/store.js'; // CAMBIO AGREGAR quitar duplicado  
  import BotonOrder from './componentes/BotonOrder.svelte'; // CAMBIO AGREGAR 
  import { fade, fly } from 'svelte/transition';
  import { push } from 'svelte-spa-router';
  import AnimationContainer from './components/AnimationContainer.svelte';
  import Navbar from './components/Navbar.svelte';
  import Titlesection from "./components/Titlesection.svelte";
  import { autentificado, prefix, urlapi, login,miPermiso,iduser,sucursal,sucursalStore } from './stores/store';

  import DatagridRow from './componentes/DatagridRow.svelte';
  import DatagridTitle from './componentes/DatagridTitle.svelte';
  import DatagridCell from './componentes/DatagridCell.svelte';
  import Datagrid from './componentes/Datagrid.svelte';

  import Infopagination from './components/Infopagination.svelte';
  import Pagination from './components/Pagination.svelte';
  import Searchsection from "./components/Searchsection.svelte";
  import { object2array, postData, verifyAccess } from './scripts';

  import moment from 'moment';

  verifyAccess($login,$miPermiso,'movimientos','access')

  /* PERMISOS */
  let viewPage=false;

  if($login===false)
  {
      push('/login')
  } else if( $miPermiso.movimientos.access===false ) {
      push('/sinpermiso')
  } else {
      viewPage=true;
  }
  /* FIN PERMISOS */

  const res=null;
  let datagrid=[]
  let cargando=false;
  let pageActual=0;
  let dataPagination={};
  let searchText='';
  let orderField='idmov';
  let orderDir='DESC';

  let avanzado=false;
  let origen='0';
  let destino='0';
  let tipo='0';
  let estado='0';
  let desde='00-00-0000';
  let hasta='00-00-0000';
  let uid=null; // CAMBIO AGREGAR VARIABLE

  let sucursales=[{0:'Sin filtrar'}];
  Object.keys($sucursalStore).map(function(value) { sucursales=[...sucursales,{[value] :$sucursalStore[value]}] });  
    
  function eventPage(event)
  {
      pageActual=event.detail.text;
      loadData()
  }

  function eventSearch(event)
  {
      pageActual=0;
      searchText=event.detail.text
      loadData()
  }

  function eventText()
  {
      pageActual=0;
      loadData()
  }

  async function loadData()
  {
      let datos={ 
          'cmd': "movimientos_list",
          sucursal: $sucursal,
          pagination: $viewsXpages,
          page: pageActual,
          order: orderField,
          dir: orderDir }

      if(avanzado===true)
      {
          if(searchText!='') datos={...datos, 'search':searchText }
          if(tipo!=='0') datos={...datos, 'tipo':tipo }
          if(estado!=='0') datos={...datos, 'estado':estado }
          if(origen!=='0') datos={...datos, 'origen':origen }
          if(destino!=='0') datos={...datos, 'destino':destino }
          if(desde!=='00-00-0000' && desde!=='') datos={...datos, 'desde':desde }
          if(hasta!=='00-00-0000' && hasta!=='') datos={...datos, 'hasta':hasta }
      }
 
      cargando=true;
      const res = await postData($urlapi, [datos])
      .then(data => {
          datagrid= object2array(data[0].result);
          dataPagination=data[0].pagination;
          cargando=false;
      });
  }

  let edit= function(id) { push('/movimiento/'+id); }
  let nuevo=function () { push('/movimiento/new')}

  function orderTable(event) {
        if(cargando===false) {
        pageActual=0;
        orderField=event.detail.order;
        orderDir=event.detail.dir;
        loadData()
        }
  }
  

  let helper=false;

  let seleccionado=false;
  let selected= function (event) { 
      if(seleccionado==false || seleccionado!==event.detail.id) {
        seleccionado=event.detail.id
      } else {
        seleccionado=false
      }
  }

  let disableEventData=false;

</script>

{#if viewPage}
<Navbar />

<AnimationContainer>
  <Titlesection>
      <span slot="title"><i class="bi bi-arrows-move me-1" />Movimientos</span>
      <span slot="toolbar">
        
        {#if $miPermiso.movimientos.insert===true}
            <button class='btn btn-primary' on:click={nuevo} on:mouseenter={()=>helper='Crear Registro'} on:mouseleave={()=>helper=false}><i class="bi bi-plus-circle"></i></button>
        {/if}
        
        {#if $miPermiso.movimientos.edit===true}
            <!-- svelte-ignore a11y-mouse-events-have-key-events -->
            <span on:mouseenter={()=>helper='Editar Registro'} on:mouseleave={()=>helper=false}>
              <button disabled={!seleccionado} class='btn btn-success' on:click={()=>edit(seleccionado)}><i class="bi bi-pencil-square"></i></button>
            </span>
        {/if}

        {#if avanzado===false}
          <button class='btn btn-secondary' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='Buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
        {:else}
          <button class='btn btn-success' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='Buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
        {/if}

        <ButtonViewsXpages on:load={()=>{pageActual=0; loadData();}} on:mouseenter={()=>helper='Registros por página'} on:mouseleave={()=>helper=false}/>

        <BotonOrder uid={uid} on:mouseenter={()=>helper='Ordenar'} on:mouseleave={()=>helper=false} />
          
      </span>
  </Titlesection>

  {#if avanzado===true}
    <div class="container-fluid mt-1" in:fly={{y:-10,duration:500}}>
        <div class="row">

            <div class='col-12 mb-2 mt-2'>
                <Input label='Filtrar por ID MOVIMIENTO' bind:value={searchText} on:change={eventText} />
            </div>          

            <div class='col-12 col-md-4 col-lg-4 mb-2'>
                <Input label='Origen' bind:value={origen} tipo='select' on:change={eventSearch} datos={sucursales} />
            </div>
            <div class='col-12 col-md-4 col-lg-4 mb-2'>
                <Input label='Destino' bind:value={destino} tipo='select' on:change={eventSearch} datos={sucursales} />
            </div>
            <div class='col-12 col-md-4 col-lg-4 mb-2'>
                <Input label='Tipo' bind:value={tipo} tipo='select' on:change={eventSearch} datos={[{'0':'Sin Filtrar'},{'I':'INGRESO'},{'S':'SALIDA'},{'T':'TRASLADO'}]} />
            </div>
            <div class='col-12 col-md-4 col-lg-4 mb-2'>
              <Input label='Estado' bind:value={estado} tipo='select' on:change={eventSearch} datos={[{'0':'Sin Filtrar'},{'P':'PENDIENTE'},{'E':'EMITIDO'},{'A':'ANULADO'}]} />
            </div>

            <div class='col-12 col-md-8 col-lg-4 mb-2'>
              <Input label='Fecha' bind:value={desde} bind:value2={hasta} tipo='range' on:change={eventSearch} />
            </div>
        </div>
    </div>
  {/if}

  <!-- DATA GRID -->
  <div class="container-fluid mt-2">
    <div class="row">
        <div class="col-12">
            <Datagrid bind:uid={uid}  order={orderField} dir={orderDir} on:order={orderTable}>

                <svelte:fragment slot="header">
                    <DatagridTitle width='100px' order="id" title='ID'/>
                    <DatagridTitle order="fecha" title='Fecha'/>
                    <DatagridTitle width='100px' order="tipo" title='Tipo'/>
                    <DatagridTitle order="origen" title='Origen'/>
                    <DatagridTitle order="destino" title='Destino'/>
                    <DatagridTitle order="estado" title='Estado'/>
                </svelte:fragment>
                <svelte:fragment slot="body">
                {#each datagrid as item}
                <DatagridRow id={item.idmov} bind:seleccionado={seleccionado} on:select={selected}>
                        <DatagridCell title='ID'>{item.idmov}</DatagridCell>
                        <DatagridCell title='Fecha'>{moment(item.fecha).format('DD/MM/YYYY, HH:mm:ss')}</DatagridCell>
                        <DatagridCell title='Tipo'>
                            {#if item.tipo=='I'}
                                <span class='text-success'><i class="bi bi-arrow-left me-1"></i>Ingreso</span>
                            {:else if item.tipo=='S'}
                                <span class='text-danger'><i class="bi bi-arrow-right me-1"></i>Salida</span>
                            {:else if item.tipo=='T'}
                                <span class='text-primary'><i class="bi bi-arrow-left-right me-1"></i>Traslado</span>
                            {/if}
                        </DatagridCell>
                        <DatagridCell title='Origen'>
                            {#if $sucursalStore[item.origen] === undefined}
                                <small class="text-secondary">No definido</small>
                            {:else}
                                <span class="badge bg-secondary">{item.origen}</span> {$sucursalStore[item.origen]}
                            {/if}
                        </DatagridCell>
                        <DatagridCell title='Destino'>
                            {#if $sucursalStore[item.destino] === undefined}
                                <small class="text-secondary">No definido</small>
                            {:else}
                                <span class="badge bg-secondary">{item.destino}</span> {$sucursalStore[item.destino]}
                            {/if}
                      </DatagridCell>                        
                        <DatagridCell title='Estado'>
                          {#if item.estado=='E'}
                              <span class='badge bg-success fw-bold'>Emitido</span>
                          {:else if item.estado=='P'}
                              <span class='badge bg-primary fw-bold'>Pendiente</span>
                          {:else if item.estado=='A'}
                              <span class='badge bg-danger fw-bold'>Anulado</span>
                          {/if}
                        </DatagridCell>
                </DatagridRow>
                {/each}
                
                </svelte:fragment>
            </Datagrid>

        </div>
    </div>
  </div>


  <!-- PAGINACIÓN -->
  <div class="container mt-3">
    <div class="row">
        <div class="col-12 col-md-6 text-end text-md-start">
        <Infopagination data={dataPagination}/>
        </div>
        <div class="col-12 col-md-6">
        <Pagination selected={pageActual} data={dataPagination} on:page={eventPage}/>
        </div>
    </div>
  </div>

  <Helper bind:text={helper}></Helper>

  <!-- <Titlesection>
      <svelte:fragment slot="title"><i class="bi bi-box-seam me-1" />Productos</svelte:fragment>
      <svelte:fragment slot="toolbar">
        <button class="btn btn-primary btn-sm" on:click={nuevo}><i class="bi bi-plus-circle me-1"></i>Nuevo Producto</button>
        {#if ordenar===false}
          <button class="btn btn-warning btn-sm" on:click={()=>{ordenar=true;}}><i class="bi bi-sort-numeric-down me-1"></i>Ordenar</button>
        {:else}
          <button class="btn btn-success btn-sm" on:click={()=>{ordenar=false;saveOrder();}}><i class="bi bi-save me-1"></i>Guardar Orden</button>
        {/if}
        
      </svelte:fragment>
  </Titlesection>

  <div animate:flip={options}></div> -->
<!-- svelte-ignore a11y-missing-attribute -->
  <!--<div class="container mt-5">
    <div class="row">

        {#each productos as item,index}
        
          <div class="col-12 col-md-6 col-lg-2 mb-4">
            <BotonCaja on:click={()=>edit(index)} id={item.id} image={item.image} color={item.color} precio={item.precio}>{item.nombre}</BotonCaja>
            {#if ordenar===true}
                <div class='mt-1'>
                  {#if index>0}
                    
                    <a class='btn btn-lg btn-outline-dark p-1 ps-2 pe-2' style='cursor:pointer' on:click={()=>orderLeft(index)}><i class="bi bi-arrow-left-circle"></i></a>
                  {/if}
                  
                  {#if index<(productos.length-1)}
                    <a class='btn btn-lg btn-outline-dark p-1 ps-2 pe-2 float-end' style='cursor:pointer' on:click={()=>orderRight(index)}><i class="bi bi-arrow-right-circle"></i></a>
                  {/if}
                </div>
            {/if}
          </div>
        {:else}
            No existen productos
        {/each}          

    </div>
  </div> -->

</AnimationContainer>
{/if}
